/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscolumnbusiness2Inputs */

const en_partnerscolumnbusiness2 = /** @type {(inputs: Partnerscolumnbusiness2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business`)
};

const de_partnerscolumnbusiness2 = /** @type {(inputs: Partnerscolumnbusiness2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betrieb`)
};

/**
* | output |
* | --- |
* | "Business" |
*
* @param {Partnerscolumnbusiness2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscolumnbusiness2 = /** @type {((inputs?: Partnerscolumnbusiness2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscolumnbusiness2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscolumnbusiness2(inputs)
	return de_partnerscolumnbusiness2(inputs)
});
export { partnerscolumnbusiness2 as "partnersColumnBusiness" }